export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/trade_icon_ordertype_select_light@2x.png";